module.exports = "<h2 rte-dialog-title>Envio de E-mail</h2>\n\n<div rte-dialog-content>\n  \n</div>\n"